/**
 * Returns the banner label for a given environment string, or null if no banner
 * should be shown (production or unset).
 */
export function getEnvironmentBannerLabel(env: string | undefined): string | null {
  if (!env || env === 'production') return null
  return `${env.charAt(0).toUpperCase()}${env.slice(1)} environment`
}

export function EnvironmentBanner() {
  const label = getEnvironmentBannerLabel(import.meta.env.VITE_ENVIRONMENT)
  if (!label) return null

  return (
    <div
      data-environment-banner
      className="fixed w-full z-20 bg-warning-accent text-center text-xs font-medium"
    >
      {label}
    </div>
  )
}
